/**
 * The in-page anchor for "where a practitioner connects their payout destination".
 *
 * BUG-222 — the wallet refuses a withdrawal whose Stripe payout destination is not
 * ready, and a refusal with no way out is the same dead end with better manners. The
 * way out is the Stripe Connect card higher up `/admin/payments`, so two files need to
 * agree on one name:
 *
 *   * `PaymentsAdmin` renders the `id` (on a WRAPPER around `StripeConnectCard`, not
 *     inside it — the card has a loading render and an error render of its own, and an
 *     anchor that exists only on the happy path is a link that sometimes does nothing);
 *   * `StripeTransactions` passes `#<anchor>` to `GatewayWallet`, which hands it to the
 *     withdrawal form.
 *
 * IT LIVES IN ITS OWN LEAF MODULE, and that is the point rather than an accident. It
 * was first exported from `StripeConnectCard.jsx`, which made `StripeTransactions`
 * import that whole card — `react-router-dom`, `@/lib/api`, `sonner` — to read one
 * string, and five existing test suites failed on the resolver before a single
 * assertion ran. A shared constant with no dependencies has no import cost, so neither
 * side pays for the other's.
 */
export const PAYOUT_SETUP_ANCHOR = "stripe-connect";
